import { render, staticRenderFns } from "./CIBNLogoList.vue?vue&type=template&id=4f7dac09&scoped=true"
import script from "./CIBNLogoList.vue?vue&type=script&lang=js"
export * from "./CIBNLogoList.vue?vue&type=script&lang=js"
import style0 from "./CIBNLogoList.vue?vue&type=style&index=0&id=4f7dac09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7dac09",
  null
  
)

export default component.exports